module.exports = __webpack_public_path__ + "img/powerpoint.6f4fe413.svg";